module.exports = "https://staticsandbox.coteibem.com.br/assets/logo-business-color-light-horizontal.7dd83847f8d27f65f06b62c9364df1ec.svg";